<mat-card *ngIf="responseDetailConstat" style="margin:20px">
    <mat-card-header>
        <mat-card-title>
            <span>Constat du {{responseDetailConstat.constat.created_at| date: "medium"}}</span>
            <span class="status-text" style="color: gray; margin-left: 5px;" *ngIf="responseDetailConstat.constat.statut_constat=='en_attente'">en attente</span>
            <span class="status-text" style="color: green; margin-left: 5px;" *ngIf="responseDetailConstat.constat.statut_constat=='validé'">validé</span>
            <span class="status-text" style="color: red; margin-left: 5px;" *ngIf="responseDetailConstat.constat.statut_constat=='refusé'">refusé</span>
        </mat-card-title>
        <mat-card-subtitle>
            <span>Vehicule : {{responseDetailConstat.constat.vehicle_value+","+responseDetailConstat.constat.vehicle_mark+' '+responseDetailConstat.constat.vehicle_model}}</span>
            <br>
            <span *ngIf="responseDetailConstat.constat.declarant_id == userIn.id">
                Locataire : {{responseDetailConstat.constat.locataire_name}}, {{responseDetailConstat.constat.locataire_phone}}
            </span>
            <span  *ngIf="responseDetailConstat.constat.locataire_id == userIn.id">
                Declarant : {{responseDetailConstat.constat.declarant_name}}, {{responseDetailConstat.constat.declarant_phone}}
            </span>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions align="start">
        <button mat-flat-button (click)="deleteConstat(responseDetailConstat.constat.id)" *ngIf="responseDetailConstat.constat.declarant_id == userIn.id && responseDetailConstat.constat.statut_constat=='en_attente'">
            <mat-icon class="mat-18" color="warn" >delete_outline</mat-icon>Supprimer !
        </button>
        <button mat-icon-button color="warn" (click)="downloadPdf(responseDetailConstat.constat.contrat)" matTooltip="Contrat" *ngIf="responseDetailConstat.constat.signature_declarant !=null && responseDetailConstat.constat.signature_locataire !=null">
            <mat-icon>receipt_long</mat-icon> Mon Contrat
        </button>
        <div *ngIf="responseDetailConstat.constat.locataire_id == userIn.id && responseDetailConstat.constat.statut_constat=='en_attente'">
            <button mat-flat-button  (click)="approuverOrRejeter(false)">
                <mat-icon class="mat-18" color="warn" >close</mat-icon>Rejeter
            </button> 
            <button mat-flat-button (click)="approuverOrRejeter(true)">
                <mat-icon class="mat-18" color="primary">done</mat-icon>Validé
            </button>  
           
        </div>       
    </mat-card-actions>
</mat-card>

<mat-stepper labelPosition="bottom" style="margin:20px" *ngIf="responseDetailConstat">
    <mat-step *ngFor="let detailconstat of responseDetailConstat.response">
        <ng-template matStepLabel style="text-align:center">{{detailconstat.libele}}</ng-template>
        <ng-template matStepContent>
            <mat-accordion class="example-headers-align">
                <mat-expansion-panel disabled>
                    <mat-expansion-panel-header>
                        <mat-panel-description style="justify-content: space-between;align-items: center;">
                        Commentaire(s)
                        <mat-icon  matTooltip="Photo">perm_media</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                </mat-expansion-panel>
                <mat-expansion-panel [expanded]="0">
                    <mat-expansion-panel-header>
                    <mat-panel-description >
                        {{detailconstat.commentaires??"Aucun commentaire"}}
                    </mat-panel-description>
                    </mat-expansion-panel-header>
                    <mat-grid-list cols="2" rowHeight="2:1">
                    <mat-grid-tile *ngFor="let file of  getpathImageOfElementConstat(detailconstat.file)" style="margin:20px">
                        <img [src]="hostService.getHttpsImage()+file" alt="" style="width: 450px;height: 300px;cursor:pointer" (click)="seeFile(hostService.getHttpsImage()+file)">
                    </mat-grid-tile>
                    </mat-grid-list>
                </mat-expansion-panel>
            </mat-accordion>               
        </ng-template>
        </mat-step>
</mat-stepper>
<mat-card>
    <mat-card-content>
        <p style="margin-bottom: 5px !important">
                      
        </p>
    </mat-card-content>
</mat-card>
            
